import { Ban, Mail, Plus, Repeat, Ticket, type LucideIcon } from 'lucide-react';

import type { GiftPassEventRow, GiftPassSource } from '../../api/gift-passes';

import { eventHeadline, formatPassDateTime, type GiftPassEventIcon } from './gift-passes-model';
import { GiftPassBookingLink } from './GiftPassBookingLink';

const ICONS: Record<GiftPassEventIcon, LucideIcon> = {
  plus: Plus,
  mail: Mail,
  ticket: Ticket,
  ban: Ban,
  repeat: Repeat,
};

const ICON_BADGE = {
  flex: '0 0 28px',
  width: 28,
  height: 28,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'var(--nb-surface)',
  color: 'var(--nb-muted)',
} as const;

const META = {
  fontSize: 11.5,
  color: 'var(--nb-subtle)',
  display: 'flex',
  gap: 6,
  flexWrap: 'wrap',
} as const;

export function GiftPassEventItem({
  event,
  source,
}: {
  event: GiftPassEventRow;
  source: GiftPassSource;
}) {
  const { label, icon } = eventHeadline(event, source);
  const Icon = ICONS[icon];
  return (
    <li
      style={{
        display: 'flex',
        gap: 12,
        padding: '12px 16px',
        borderBottom: '1px solid var(--nb-border)',
      }}
    >
      <span style={ICON_BADGE} aria-hidden>
        <Icon size={14} />
      </span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, overflowWrap: 'anywhere' }}>{label}</div>
        <div style={META}>
          <span>{formatPassDateTime(event.createdAt)}</span>
          {event.booking && <GiftPassBookingLink {...event.booking} />}
          {event.note && <span>{event.note}</span>}
        </div>
      </div>
    </li>
  );
}
